module.exports = __webpack_public_path__ + "2acb60f2/img/copy-icon.408fdb2d.svg";